<template>
  <el-dialog
  :visible="dialogVisible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
  <GalleryController :selection="selection" :multiple="multiple"  @select="handleSelection" style="margin-top:-50px;"></GalleryController>
  <span slot="footer" class="dialog-footer">
    <el-button @click="close">Annuler</el-button>
    <el-button @click="add" :disabled="this.asset.length==0">Ajouter</el-button>
  </span>
</el-dialog>
</template>
<script>

import GalleryController from './gallery-controller'
import { EventBus } from '@/core/event-bus'

export default {
  name: 'galery-dialog',
	props: {
		dialogVisible : Boolean,
    selection : {type : Boolean, default : false},
    multiple : {type : Boolean, default : false}
	},
  data() {
    return {
      asset  : [],
      fullScreenLoading : false,
    };
  },components: {
    GalleryController
  },
	methods: {
    handleSelection(selectedAssets){
      this.asset = selectedAssets;
    },
    resetFields(){
      this.asset  = [];
      this.fullScreenLoading = false;
    },
    open(){

    },
    add(){
      this.$emit('select',this.asset);
      this.close();
    },
    close(){
      this.$emit('close');
      EventBus.$emit('close-galery-dialog');
      this.resetFields();

    },
	},
	computed: {

	}
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';


.el-form-item{
  margin-bottom:20px;
}



  .dialog-footer{
    position: fixed;
    display: block;
    bottom: 0px;
    width: 100%;
    background-color: #f3f7fa;
    height:50px;
    margin-left:-20px;
    padding-top:10px;
    border-top:1px solid #E4E7ED;
    z-index:100;
  }

  .item {
    //padding: 20px;
    //margin: 20px 0;
    margin-bottom: 20px;
    //border-radius: 5px;
    opacity: .85;
    transition: all .25s;

    /* masonry */
    //display: inline-block;
    box-sizing: border-box;
    width: 100%;

    img {
      width: 100%;
      max-width: 100%;
    }

    &:hover {
      cursor:pointer;
      opacity: 1;
      box-shadow: 0px 0px 0px 4px $text-color-accent;
    }
  }

</style>
